import { buildLandingStore } from "../setups/landing";

// Defines the search form state for the landing pages
if (!window.store) {
  window.store = buildLandingStore();
}
